import React from 'react'
import Title from '../../../../components/typography/title.component'
import Button from '../../../../components/buttons/buttons.component'
import PeriodInputs from '../../../../components/form-components/period-inputs.component'
import ClientTicketModal from './components/client-ticket-modal-container.component'
import InnerPageContainer from '../../../../components/layout/private/inner-page-container.component'
import PurchasePagination from './components/purchase-pagination-container.component'
import LegacySyncBanner from './components/legacy-sync-banner.component'
import { Formik } from 'formik'
import { connect } from 'react-redux'
import { StyledForm } from './styles/styled-form.style'
import { withRouter } from 'react-router-dom'
import { myPurchasesActions } from './my-purchases.actions'
import { SaleService } from '../../../../services/sale.service'
import { clientActions, toastActions } from '../../../../actions'
import { bindActionCreators } from 'redux'
import {
	SelectInput,
	AsyncSelectInput
} from '../../../../components/form-components/inputs.component'

class MyPurchasesPage extends React.Component {
	constructor(props) {
		super(props)

		this.isExporting = false
		// TODO: verificar a possibilidade de criar um ducks pra isso
		this.state = {
			period: 30,
			status: '',
			products: [],
			productId: '',
			dateEnd: null,
			dateStart: null,
			forceReloadData: 0,
			// Estado do historico do legado, devolvido pela propria consulta da lista.
			legacySync: null
		}

		// Acompanhamento da busca em segundo plano: enquanto ela roda, a lista se recarrega sozinha
		// até o histórico aparecer. Sem isso o cliente precisaria recarregar a página na mão.
		this.temporizadorDaBusca = null
		this.tentativasDeAcompanhamento = 0
		// Instante do último "Consultar" aceito (intervalo mínimo entre cliques sem mudança de filtro).
		this.ultimaConsulta = 0

		this.onSubmit = onSubmit.bind(this)
		this.onLegacySyncChange = onLegacySyncChange.bind(this)
		this.pararAcompanhamento = pararAcompanhamento.bind(this)
		this.acompanharBuscaEmSegundoPlano = acompanharBuscaEmSegundoPlano.bind(this)
		this.loadOptions = loadOptions.bind(this)
		this.renderFormik = renderFormik.bind(this)
		this.handleCancelSomeTicket = handleCancelSomeTicket.bind(this)
	}

	componentWillMount() {
		this.props.getAvailablePointsToBuy()
	}

	componentWillUnmount() {
		this.pararAcompanhamento()
	}

	componentDidMount() {
		setTimeout(() => {
			// Sair da tela antes do disparo desmonta o componente e zera as refs: sem esta guarda,
			// o timer estoura em cima de uma ref nula.
			if (this.refs.form) this.refs.form.submitForm()
		}, 0)

		SaleService.getProducts()
			.then(({ data }) => {
				this.setState({ products: data })
			})
			.catch(() => {
				this.props.toastWarning({
					message: 'Não foi possível carregar a lista de produtos.'
				})
			})
	}

	render() {
		const { availablePointsToBuy } = this.props
		const { dateStart, dateEnd, productId, status, forceReloadData, legacySync } = this.state
		const annualLimit = Number(250000).toLocaleString('pt-BR')
		// TODO: user selectors
		const availablePoints = Number(availablePointsToBuy).toLocaleString(
			'pt-BR'
		)

		return (
			<InnerPageContainer>
				<Title>Minhas compras</Title>
				<h3 className="center">
					Você ainda pode comprar{' '}
					<span className="blue bold">{availablePoints}</span> pontos
					Muviflex
				</h3>
				<p className="center">
					Limite anual: {annualLimit} pontos para compra
				</p>
				<h3 className="semi-bold orange">Filtros</h3>
				<Formik
					ref="form"
					onSubmit={this.onSubmit}
					initialValues={this.state}
					render={this.renderFormik}
				/>
				<LegacySyncBanner legacySync={legacySync} />
				<PurchasePagination
					params={{ dateStart, dateEnd, productId, status }}
					forceReloadData={forceReloadData}
					onLegacySyncChange={this.onLegacySyncChange}
				/>
				<ClientTicketModal handleCancelTicket={this.handleCancelSomeTicket} />
			</InnerPageContainer>
		)
	}
}

function onSubmit(values) {
	const { exportData } = this.props
	const params = Object.assign({}, values)
	if (this.isExporting) {
		this.isExporting = false
		exportData(params)
	} else {
		const filtros = {
			status: values.status,
			dateEnd: values.finalDate,
			productId: values.productId,
			dateStart: values.initialDate
		}
		// A lista só recarrega sozinha quando algum filtro muda (mesma comparação do PaginationComponent).
		// Com os mesmos filtros o "Consultar" não consultava nada — pedido novo ou situação nova só
		// apareciam recarregando a página. Aí pede a recarga explícita; com filtro mudado, não (seriam
		// duas consultas).
		const algumFiltroMudou = Object.keys(filtros).some(
			chave => filtros[chave] !== this.state[chave]
		)

		// Cliques seguidos sem mudar filtro: ignora em silêncio os que caem dentro do intervalo mínimo
		// desde o último "Consultar" aceito, para não disparar uma consulta por clique. Filtro mudado
		// consulta sempre. O clique ignorado não reinicia a contagem.
		const agora = Date.now()
		if (
			!algumFiltroMudou &&
			agora - this.ultimaConsulta < INTERVALO_MINIMO_ENTRE_CONSULTAS_MS
		)
			return
		this.ultimaConsulta = agora

		this.setState(
			algumFiltroMudou ? filtros : { forceReloadData: Math.random() }
		)
	}
}

const INTERVALO_MINIMO_ENTRE_CONSULTAS_MS = 2000

function onLegacySyncChange(legacySync) {
	const status = (legacySync && legacySync.status) || 'never'

	this.setState({ legacySync })

	if (status === 'syncing') this.acompanharBuscaEmSegundoPlano()
	else this.pararAcompanhamento()
}

const INTERVALO_DE_ACOMPANHAMENTO_MS = 6000
const MAXIMO_DE_TENTATIVAS = 25

/**
 * Recarrega a lista de tempos em tempos enquanto a busca no legado está em curso, para as compras
 * aparecerem sozinhas quando ela terminar. Para no primeiro estado diferente de `syncing` (o
 * onLegacySyncChange cuida disso) ou ao esgotar as tentativas — cerca de dois minutos e meio, bem
 * acima do tempo observado da busca. O teto existe para uma busca travada não deixar a tela
 * recarregando para sempre.
 */
function acompanharBuscaEmSegundoPlano() {
	if (this.temporizadorDaBusca) return

	this.tentativasDeAcompanhamento = 0
	this.temporizadorDaBusca = setInterval(() => {
		this.tentativasDeAcompanhamento += 1

		if (this.tentativasDeAcompanhamento > MAXIMO_DE_TENTATIVAS) {
			this.pararAcompanhamento()
			return
		}

		this.setState({ forceReloadData: Math.random() })
	}, INTERVALO_DE_ACOMPANHAMENTO_MS)
}

function pararAcompanhamento() {
	if (!this.temporizadorDaBusca) return

	clearInterval(this.temporizadorDaBusca)
	this.temporizadorDaBusca = null
}

function handleCancelSomeTicket() {
	const data = Math.random()
	this.setState({ forceReloadData: data })
}

function renderFormik(props) {
	return (
		<StyledForm noValidade onSubmit={props.handleSubmit}>
			<PeriodInputs {...props} />
			<AsyncSelectInput
				{...props}
				id="productId"
				label="Produto"
				style={{ width: '100%' }}
				loadOptions={this.loadOptions}
				defaultOptions={this.state.products}
			/>
			<SelectInput
				{...props}
				id="status"
				label="Situação"
				options={statusOptions}
				defaultValue={statusOptions[0]}
			/>
			<div className="buttons">
				<Button
					secondary
					type="button"
					onClick={exportData.bind(this)}>
					Exportar compras de passagem
				</Button>
				<Button primary type="submit">
					Consultar
				</Button>
			</div>
		</StyledForm >
	)
}

function exportData() {
	this.isExporting = true
	this.refs.form.submitForm()
}

function loadOptions(inputValue, callback) {
	callback(
		[{ value: '', label: 'Todos' }, ...this.state.products]
			.filter(d =>
				d.label.toLowerCase().includes((inputValue || '').toLowerCase())
			)
			.slice(0, 11)
			.map(({ label, value }) => ({
				value,
				label
			}))
	)
}

const statusOptions = [
	{ value: '', label: 'Todas' },
	{ value: 'Pendente', label: 'Pendente' },
	{ value: 'Concluído', label: 'Concluído' },
	{ value: 'Cancelado', label: 'Cancelado' },
	{ value: 'Falhou', label: 'Falhou' },
	{ value: 'Reembolsado', label: 'Reembolsado' }
]

const mapStateToProps = ({ client }) => ({
	availablePointsToBuy: client.availablePointsToBuy
})

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			...myPurchasesActions,
			toastWarning: toastActions.warning,
			getAvailablePointsToBuy: clientActions.getAvailablePointsToBuy
		},
		dispatch
	)

const connectedMyPurchasePage = withRouter(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(MyPurchasesPage)
)

export { connectedMyPurchasePage as ModuleRootComponent }
